import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import 'app/assets/css/font-icons.css';

import { handleAuthentication, mfaOtpAuthentication, generateMfaOtp, mfaAuthLoader, mfaOtpLoader, logoutUser } from 'app/actions/AuthedActions';
import OTP from './OTPContainer';

const mapStateToProps = (state) => ({
    isLoggedIn: state.authed.accessToken,
    userEmail: state.authed.user.email,
    errorMsg: state.authed.mfaErrMsg,
    authJWT: state.authed.authJWT,
    isVerifying: mfaAuthLoader(state),
    isCreatingOtp: mfaOtpLoader(state),
});

const mapDispatchToProps = (dispatch) => ({
    handleAuth: (h) => dispatch(handleAuthentication(h)),
    mfaOtpAuth: (uId, otp, nextUrl) => dispatch(mfaOtpAuthentication(uId, otp, nextUrl)),
    generateMfaOtp: (uId) => dispatch(generateMfaOtp(uId)),
    push: (f) => dispatch(push(f)),
    logout: () => dispatch(logoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(OTP);
